import React from 'react';
import { AmountFormatter } from './Formatters/AmountFormatter.inner';
import { DateFormatter } from './Formatters/DateFormatter.inner';
import { IdNumberFormatter } from './Formatters/IdNumberFormatter.inner';
import { DescriptionFormatter } from './Formatters/DescriptionFormatter.inner';
import { HeaderFormatter } from './Formatters/HeaderFormatter.inner';
import { NumberFormatter } from './Formatters/NumberFormatter.inner';
import { ButtonFormatter } from './Formatters/ButtonFormatter.inner';
import { ToggleFormatter } from './Formatters/ToggleFormatter.inner';
import { BrandFormatter } from './Formatters/BrandFormatter.inner';
import { CheckboxFormatter } from './Formatters/CheckboxFormatter.inner';
import { StatusFormatter } from './Formatters/StatusFormatter.inner';
import { CardNumberFormatter } from './Formatters/CardNumberFormatter.inner';
import { IconActionFormatter } from './Formatters/IconActionFormatter.inner';
import { MoreActionsFormatter } from './Formatters/MoreActionsFormatter.inner';

export const formatters = {
  AmountFormatter: (cell, row, rowIndex, formatExtraData) => (
    <AmountFormatter cell={cell} formatExtraData={formatExtraData} />
  ),
  DateFormatter: (cell, row, rowIndex, formatExtraData) => (
    <DateFormatter cell={cell} formatExtraData={formatExtraData} />
  ),
  IdNumberFormatter: (cell, row, rowIndex, formatExtraData) => (
    <IdNumberFormatter
      cell={cell}
      row={row}
      formatExtraData={formatExtraData}
    />
  ),
  DescriptionFormatter: (cell, row, rowIndex, formatExtraData) => (
    <DescriptionFormatter cell={cell} formatExtraData={formatExtraData} />
  ),
  HeaderFormatter: (column, colIndex, components) => (
    <HeaderFormatter column={column} />
  ),
  NumberFormatter: (cell, row, rowIndex, formatExtraData) => (
    <NumberFormatter cell={cell} formatExtraData={formatExtraData} />
  ),
  ButtonFormatter: (cell, row, rowIndex, formatExtraData) => (
    <ButtonFormatter cell={cell} formatExtraData={formatExtraData} />
  ),
  ToggleFormatter: (cell, row, rowIndex, formatExtraData) => (
    <ToggleFormatter cell={cell} formatExtraData={formatExtraData} />
  ),
  BrandFormatter: (cell, row, rowIndex, formatExtraData) => (
    <BrandFormatter cell={cell} formatExtraData={formatExtraData} />
  ),
  CheckboxFormatter: (cell, row, rowIndex, formatExtraData) => (
    <CheckboxFormatter cell={cell} formatExtraData={formatExtraData} />
  ),
  StatusFormatter: (cell, row, rowIndex, formatExtraData) => (
    <StatusFormatter cell={cell} formatExtraData={formatExtraData} />
  ),
  CardNumberFormatter: (cell, row, rowIndex, formatExtraData) => (
    <CardNumberFormatter cell={cell} formatExtraData={formatExtraData} />
  ),
  IconActionFormatter: (cell, row, rowIndex, formatExtraData) => (
    <IconActionFormatter
      cell={cell}
      row={row}
      formatExtraData={formatExtraData}
    />
  ),
  MoreActionsFormatter: (cell, row, rowIndex, formatExtraData) => (
    <MoreActionsFormatter cell={cell} formatExtraData={formatExtraData} />
  ),
};

export const cellAligns = {
  AmountFormatter: 'right',
  IdNumberFormatter: 'left',
  DateFormatter: 'left',
  DescriptionFormatter: 'left',
  NumberFormatter: 'center',
  ButtonFormatter: 'center',
  ToggleFormatter: 'center',
  BrandFormatter: 'center',
  CheckboxFormatter: 'center',
  StatusFormatter: 'center',
  CardNumberFormatter: 'left',
  IconActionFormatter: 'center',
};

const validateCellAlign = (value) =>
  ['left', 'right', 'center'].includes(value);

export const columnsFormatter = ({ columns, clickableRows }) => {
  return columns.map((column) =>
    formatters[column.formatter] !== undefined
      ? {
          ...column,
          align:
            column?.align && validateCellAlign(column?.align)
              ? column?.align
              : cellAligns[column.formatter],
          formatter: formatters[column.formatter],
          formatExtraData: {
            ...column.formatExtraData,
            align: cellAligns[column.formatter],
            clickableRows: clickableRows,
          },
          headerAlign:
            column?.align && validateCellAlign(column?.align)
              ? column?.align
              : cellAligns[column.formatter],
          headerFormatter: formatters['HeaderFormatter'],
        }
      : { ...column, headerFormatter: formatters['HeaderFormatter'] }
  );
};
